import React, {useContext} from 'react';
import Page from '../../components/Page';
import ViewBanner from "../../components/ViewBanner";
import PageContext from "../../contexts/Page";

import "./PrivacyPolicy.scss";

const PrivacyPolicy = () => {

	const { pageData } = useContext(PageContext);
	const { tytul, tekst_regulacji } = pageData;

	return (
		<Page>
			<ViewBanner title={tytul}/>
			<div className="row privacy-policy">
				<div className="col col-xs-12">
					<div className="row boxed">
						<div className="col col-xs-12">
							<article dangerouslySetInnerHTML={{__html:tekst_regulacji}}/>
						</div>
					</div>
				</div>
			</div>
		</Page>
	);
};

export default PrivacyPolicy;